import { GraphDirectoryObject } from '../../models/graph';
import { createStringIdAdapter } from './common/string-id-adapter';

export const graphDirectoryObjectAdapter = createStringIdAdapter<GraphDirectoryObject>();
